import { useEffect, useMemo } from 'react';

import { CourseStore } from '../stores/CourseStore';
import { DepartmentsStore } from '../stores/DepartmentsStore';
import { ReservationStore } from '../stores/ReservationStore';

/**
 * 自動で診療科とコースを選択するフック
 * URLのクエリパラメータから診療科とコースを取得し、ReservationStoreに設定する
 */
export const useAutoDepartmentAndCourseSelect = (store: ReservationStore) => {
  const departmentStore = useMemo(() => new DepartmentsStore(), []);
  const coursesStore = useMemo(() => new CourseStore(), []);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const departmentId = params.get('department');
    const treatmentKindId = params.get('treatmentKind');

    // department が無ければ何もしない
    if (!departmentId) {
      return;
    }

    Promise.all([departmentStore.fetchDepartments(), coursesStore.fetchCourses()]).then(() => {
      const foundDept = departmentStore.departments.find(d => d.id === departmentId);
      if (foundDept) {
        store.setDepartment(foundDept);
      }

      if (treatmentKindId) {
        const foundCourse = coursesStore.courses.find(c => c.id === treatmentKindId);
        if (foundCourse) {
          store.setTreatmentKind(foundCourse);
        }
      }
    });
  }, [departmentStore, coursesStore, store]);
};
